import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        inserirCliente(cliente){
            return instance({
                method: 'post',
                baseURL,
                url: 'Cliente/CadastrarCliente',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(cliente),
            });
        },
        atualizarCliente(cliente, idUserAlteracao){
            return instance({
                method: 'post',
                baseURL,
                url: 'Cliente/EditarCliente',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'cliente': cliente, 'idUserAlteracao': idUserAlteracao }),
            });
        },
        getClisExibicao(filters){
            return instance({
                method: 'post',
                baseURL,
                url: 'Cliente/RecuperarClienteExibicao',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes(filters),
            });
        },
        buscarClienteId(id){
            return instance({
                method: 'post',
                baseURL,
                url: 'Cliente/BuscarClienteId',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({'Id': id})
            });
        },
        getListarClientes(){
            return instance({
                method: 'get',
                baseURL,
                url: 'Cliente/ListarCliente',
                responseType: 'json',
                headers: headers
            });
        },
        buscarClientePeloIdUsuario(id){
            return instance({
                method: 'post',
                baseURL,
                url: 'Cliente/BuscarClientePeloIdUsuario',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({'Id': id})
            });
        }
    }
    return apiCalls;
}
